// app-shell — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: flex;
    flex-direction: column;
    min-height: 100dvh;
    background: var(--run-wf-surface);
    color: var(--run-wf-text);
    font-family: var(--run-wf-font-family);
    font-weight: 400;
  }

  .shell-frame {
    display: flex;
    flex-direction: column;
    /* Fill the host (see default skin) — :host keeps the 100dvh default;
       embedded/sized hosts get a fitting frame so the footer is visible. */
    flex: 1 1 auto;
    min-height: 0;
    position: relative;
  }

  .shell-header {
    position: sticky;
    top: 0;
    z-index: var(--run-shell-z-index-header, 100);
    height: var(--run-shell-header-height, 3.5rem);
    background: var(--run-wf-surface-raised);
    border-bottom: 1px dashed var(--run-wf-border);
    box-shadow: none;
    display: flex;
    align-items: center;
  }

  .shell-body {
    display: flex;
    flex: 1 1 auto;
    overflow: hidden;
    max-width: var(--run-shell-content-max-width, 87.5rem);
    width: 100%;
    margin-inline: auto;
  }

  .shell-side-nav {
    flex: 0 0 var(--run-shell-side-nav-width, 16rem);
    width: var(--run-shell-side-nav-width, 16rem);
    background: var(--run-wf-surface-raised);
    border-right: 1px dashed var(--run-wf-border);
    overflow-y: auto;
    transition: transform 0.25s ease;
  }

  .shell-side-nav[aria-hidden="true"] {
    display: none;
  }

  .shell-main {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: var(--run-app-shell-padding-block, var(--run-space-semantic-sm)) var(--run-app-shell-padding-inline, var(--run-space-semantic-sm));
  }

  .shell-footer {
    background: var(--run-wf-surface-raised);
    border-top: 1px dashed var(--run-wf-border);
  }

  .shell-route-announcer {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    white-space: nowrap;
  }

  .shell-scrim {
    display: none;
    position: fixed;
    inset: 0;
    z-index: var(--run-shell-z-index-scrim, 190);
    background: var(--run-wf-overlay);
  }

  @media (max-width: calc(var(--run-shell-breakpoint, 1024px) - 1px)) {
    .shell-side-nav {
      position: fixed;
      inset-block: 0;
      inset-inline-start: 0;
      z-index: var(--run-shell-z-index-drawer, 200);
      transform: translateX(-100%);
    }

    :host([nav-open]) .shell-side-nav {
      transform: translateX(0);
    }

    :host([nav-open]) .shell-scrim {
      display: block;
    }
  }
`;

export function render(host) {
  const { navOpen, _hasSideNav } = host;
  host.shadowRoot.innerHTML = `
    <div class="shell-frame">
      <header class="shell-header">
        <slot name="header"></slot>
      </header>
      <div class="shell-body">
        <nav class="shell-side-nav" aria-hidden="${_hasSideNav ? 'false' : 'true'}">
          <slot name="side-nav"></slot>
        </nav>
        <main class="shell-main">
          <slot name="main"></slot>
        </main>
      </div>
      <footer class="shell-footer">
        <slot name="footer"></slot>
      </footer>
      <div class="shell-route-announcer">
        <slot name="route-announcer"></slot>
      </div>
      <div class="shell-scrim" aria-hidden="true"></div>
    </div>
  `;
}